import { render, staticRenderFns } from "./replacephone.vue?vue&type=template&id=736469a5&scoped=true"
import script from "./replacephone.vue?vue&type=script&lang=js"
export * from "./replacephone.vue?vue&type=script&lang=js"
import style0 from "./replacephone.vue?vue&type=style&index=0&id=736469a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736469a5",
  null
  
)

export default component.exports